<template>
  <div class="wrapper" style="display: flex">
    <v-tooltip bottom> </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="tooltip" v-bind="attrs" v-on="on"> ? </v-btn>
      </template>
      <span
        >Deve ser indicado qual é o percentual do valor econômico e financeiro
        que o Sebrae assume. Exemplo: Se o Sebrae não cobra nada da prefeitura,
        o subsídio do Sebrae é de 100%</span
      >
    </v-tooltip>

    <v-select
      class="tema-eixo-combo"
      id="temas-select"
      v-model="filter.contratoSubsidio"
      item-text="label"
      item-value="value"
      :items="subsidios"
      label="Subsídio Sebrae"
      placeholder="Subsídio Sebrae"
      :clearable="true"
    >
      <template slot="no-data"> Nenhum Subsídio Sebrae retornado </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "AppSubsidioCombobox",
  props: ["filter"],
  mounted() {
    this.calcSubsidio();

    this.filter.contratoSubsidio = parseInt(this.filter.contratoSubsidio);
  },
  methods: {
    calcSubsidio() {
      this.subsidios = [{ label: "0%", value: 0 }];

      let subAux = 0;
      for (let i = 0; subAux < 100; i++) {
        subAux += 5;
        this.subsidios.push({ label: `${subAux}%`, value: subAux });
      }
    },
  },
  data() {
    return {
      subsidios: [],
    };
  },
};
</script>
<style scoped>
.wrapper {
  position: relative;
}
.tooltip {
  background: var(--corPrimaria) !important;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  left: 90px;
  top: 3px;
  padding: 5px !important;
  width: 15px !important;
  height: 15px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  cursor: pointer;
  z-index: 4;
  min-width: unset !important;
}
</style>
